function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12.44h6.265a3.395 3.395 0 006.694 0h1.743a.565.565 0 100-1.13h-1.743a3.395 3.395 0 00-6.694 0H1a.565.565 0 000 1.13zm7.35-.565a2.262 2.262 0 104.525 0 2.262 2.262 0 00-4.524 0M9.435 3.394a3.4 3.4 0 00-6.694 0H1a.566.566 0 100 1.131h1.74a3.4 3.4 0 006.695 0H15.7a.565.565 0 100-1.13H9.436zM6.09 6.221a2.262 2.262 0 110-4.524 2.262 2.262 0 010 4.524"
});

function SvgIconFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgIconFilters;